// extracted by mini-css-extract-plugin
module.exports = {"updateButton":"Row_updateButton__foLX4","deleteButton":"Row_deleteButton__1VNz4"};